import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";
import { CustomerSubscriptionFrequency } from "src/app/shared/models/enums/customer-subscription-frequency.enum";

@Component({
	selector: "app-subscription-record-view",
	templateUrl: "./subscription-record-view.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class SubscriptionRecordViewComponent implements OnInit {
	@Input() subscriptionRecordsSelected: CustomerSubscriptionItem[];
	@Output() subscriptionRecordsSelectedChange = new EventEmitter<CustomerSubscriptionItem[]>();

	@Input() bulkEdit: boolean;
	@Output() bulkEditChange = new EventEmitter<boolean>();

	@Input() subscriptionItem: CustomerSubscriptionItem;
	@Output() subscriptionItemChange = new EventEmitter<number>();

	constructor(public app: AppService, public customerService: CustomerService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		console.log(this.bulkEdit);
		console.log(this.subscriptionRecordsSelected);
		if (this.bulkEdit && this.subscriptionRecordsSelected?.length > 0) {
			const defaultInactive = this.subscriptionRecordsSelected.some((i) => i.inactive);
			this.subscriptionItem = new CustomerSubscriptionItem({
				inactive: defaultInactive,
			});
		}
	}

	onSave() {
		if (this.bulkEdit) {
			this.subscriptionRecordsSelected.forEach((subscription) => {
				if (this.subscriptionItem.inactive) {
					subscription.inactive = this.subscriptionItem.inactive;
				}

				if (this.subscriptionItem.menuItemKey) {
					subscription.menuItemKey = this.subscriptionItem.menuItemKey;
					subscription.priceNumber = this.subscriptionItem.priceNumber;
					subscription.ooMenuItem = this.customerService.venueService.ooMenuItems.find((i) => i.menuItemKey === subscription.menuItemKey);
					subscription.price = this.customerService.venueService.menuItemGetPriceFromNumber(subscription.ooMenuItem, subscription.priceNumber);
				}

				if (this.subscriptionItem.nextBillDate) {
					subscription.nextBillDate = this.subscriptionItem.nextBillDate;
					subscription.nextBillDateDate = this.app.moment.unix(subscription.nextBillDate).toDate();
				}

				if (this.subscriptionItem.frequency) {
					subscription.frequency = this.subscriptionItem.frequency;
					subscription.frequencyDisplayName = this.app.references.toTitleCase(CustomerSubscriptionFrequency[subscription.frequency]);
				}

				this.customerService.subscriptionSave(subscription);
			});
		} else {
			this.customerService.subscriptionSave(this.subscriptionItem);
		}

		this.customerService.customerSubscriptionItemList.next(this.customerService.customerSubscriptionItemList.value);
	}

	setItem() {
		this.subscriptionItem.ooMenuItem = this.customerService.venueService.ooMenuItems.find((item) => item.menuItemKey === this.subscriptionItem.menuItemKey);
	}

	onDelete() {
		this.customerService.subscriptionDelete(this.subscriptionItem.sk);
		this.subscriptionItemChange.emit(undefined);
	}
}
